import React, { useContext } from 'react';
import { useHistory } from 'react-router';
import styled from 'styled-components';
import Bg from '../../images/homeBg.png';
import { transports } from '../../utils/data';
import Store from '../../utils/Store';
const Home = () => {
	const { dispatch } = useContext(Store);
	const history = useHistory();

	const selectTransport = (id) => {
		const selectedTransport = transports.find(
			(transport) => transport.id === id
		);

		dispatch({ type: 'SELECT_TRANSPORT', payload: selectedTransport });
		history.push('./destination');
	};
	return (
		<>
			<Wrapper>
				<BoxWrapper>
					{transports.map((transport) => {
						const { id, transportType, img } = transport;

						return (
							<Box key={Math.random()} onClick={() => selectTransport(id)}>
								<img src={img} alt={transportType} />
							</Box>
						);
					})}
				</BoxWrapper>
			</Wrapper>
		</>
	);
};

export default Home;

const Wrapper = styled.div`
	background: url(${Bg});
	background-repeat: no-repeat;
	background-size: cover;
	height: 95vh;
	background-position: center center;
	width: 100vw;
	height: 90vh;
	display: grid;
	justify-content: center;
	align-items: center;

	@media screen and (max-width: 800px) {
		background-image: linear-gradient(#87ddf4, #ffffff);
		padding-top: 20px;
	}
`;

const BoxWrapper = styled.div`
	width: 95vw;
	display: grid;
	justify-content: center;
	align-items: center;
	grid-template-columns: repeat(auto-fit, 200px);
	grid-gap: 30px;
`;
const Box = styled.div`
	height: 200px;
	background: #fff;
	border-radius: 10px;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;

	img {
		width: 100px;
		height: auto;
	}
`;
